import { Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

export const ProvidedByFigures = () => {
  const { t } = useTranslation("global_compensation_calculator/Result")

  return (
    <Text size="small" className="items-center  text-gray-300 md:flex">
      {t("providedByFigures")}:&nbsp;
      <a
        href="https://figures.hr/"
        rel="noopener noreferrer"
        target="_blank"
        className="flex items-center text-gray-400"
      >
        <img src="/images/figures-logo.svg" alt="figures" className="mt-1 w-5 md:ml-1 md:mt-0" />
        &nbsp;Figures
      </a>
    </Text>
  )
}
